<template>
  <v-app id="app">
    <core-app-bar />
    <core-drawer />
    <core-view />

    <snackbars />
    <LightBox />
  </v-app>
</template>

<script>
import Snackbars from "@/plugins/notifications/Snackbars";
import ToolbarAvatar from "@/components/ToolbarAvatar";
import CoreDrawer from "@/views/layouts/core/CoreDrawer";
import CoreAppBar from "@/views/layouts/core/CoreAppBar";
import CoreView from "@/views/layouts/core/CoreView";
import LightBox from "@/modules/light-box/LightBox.vue";

export default {
  name: "DefaultLayout",

  components: {
    LightBox,
    CoreView,
    CoreAppBar,
    CoreDrawer,
    ToolbarAvatar,
    Snackbars,
  },

  data: () => ({
    drawer: null,
    showMenu: true,
  }),

  created() {
    // Получение глобальных GET параметров
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("showMenu")) {
      this.showMenu = true;
    }
  },
};
</script>

<style scoped lang="scss"></style>
